import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { taxZoneEndpoints } from '@/lib/api/endpoints';
import { taxZoneKeys } from '@/lib/queryKeys';

export type TaxOverrideLevel = 'federal' | 'state' | 'provincial' | 'county' | 'city' | 'zip';

export interface TaxOverrideRow {
  id: string;
  level: TaxOverrideLevel;
  jurisdiction: string;
  taxCodeName: string | null;
  originalRate: number | null;
  originalAppliesTo: 'all' | 'materials' | 'labor' | 'freight';
  rateOverride: number | null;
  appliesToOverride: 'all' | 'materials' | 'labor' | 'freight' | null;
  restoreEndpoint: string;
  restoreMethod: 'PATCH' | 'POST';
}

interface TaxOverridesResponse {
  overrides: TaxOverrideRow[];
}

/**
 * NOT-130 — Flat feed of every active override across the tenant.
 * Includes BOTH tax_code level overrides (federal/state/county/city) and
 * tax_zone_index level overrides (per-ZIP). The Overrides Viewer page
 * renders this as a single sortable/filterable table.
 */
export function useTaxOverrides() {
  return useApiQuery<TaxOverridesResponse>({
    queryKey: taxZoneKeys.overrides(),
    queryFn: () => apiGet<TaxOverridesResponse>(operationsClient, taxZoneEndpoints.overrides()),
  });
}
